import { counterType } from "../SystemState";
import { setTextIfNew } from "../util/ui/Node";
import { CounterType as CounterType } from "../domain/CounterType";
import { createElement } from "../util/ui/Element";
import { addKeyboardBinding } from "../util/ui/Keyboard";
export class Counter {
    constructor(editor, dropdown = new CounterOptionsDropdown()) {
        this.editor = editor;
        this.dropdown = dropdown;
        this.counterView = document.getElementById("counter");
        this.containerView = document.getElementById("counterContainer");
        editor.on("text-change", () => this.updateCounter());
        this.updateCounter();
        this.setupDropdown();
        counterType.observe(() => this.updateType());
        addKeyboardBinding({ code: "KeyC", shortKey: true, shiftKey: true }, () => this.counterView.focus());
    }
    setupDropdown() {
        this.counterView.onmouseenter = this.counterView.onfocus = () => {
            this.dropdown.show();
            this.dropdown.selectType(counterType.value);
            this.dropdown.update(this.editor.getText());
        };
        this.containerView.addEventListener("focusout", e => {
            if (this.shouldHideDropdown(e))
                this.dropdown.hide();
        });
    }
    shouldHideDropdown(e) {
        return !this.containerView.contains(e.relatedTarget);
    }
    updateCounter() {
        setTextIfNew(this.counterView, counterType.value.getLabel(this.editor.getText()));
    }
    updateType() {
        this.dropdown.selectType(counterType.value);
        this.dropdown.hide();
        this.updateCounter();
    }
}
export class CounterOptionsDropdown {
    constructor() {
        this.view = document.getElementById("counterOptions");
        this.options = CounterType.values.map(type => {
            return new CounterOption(type, this.view);
        });
        this.view.onmouseleave = () => this.hide();
    }
    get isShown() {
        return this.view.classList.contains("-active");
    }
    update(text) {
        this.options.forEach(option => option.update(text));
    }
    show() {
        this.view.classList.add("-active");
    }
    hide() {
        this.view.classList.remove("-active");
    }
    selectType(type) {
        this.options.forEach(option => {
            option.setActive(option.type == type);
        });
    }
}
export class CounterOption {
    constructor(type, parentElement) {
        this.type = type;
        this.view = createElement("li", "quillCounter__option", parentElement);
        this.view.tabIndex = 0;
        this.view.onclick = () => counterType.value = type;
        this.view.onkeydown = (e => {
            if (e.code == "Enter" || e.code == "Space")
                counterType.value = type;
        });
    }
    update(text) {
        setTextIfNew(this.view, this.type.getLabel(text));
    }
    setActive(isActive) {
        if (isActive)
            this.activate();
        else
            this.deactivate();
    }
    activate() {
        this.view.classList.add("-active");
    }
    deactivate() {
        this.view.classList.remove("-active");
    }
}
